import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-new-invitation-created',
  templateUrl: './new-invitation-created.component.html',
  styleUrls: ['./new-invitation-created.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewInvitationCreatedComponent {
  @Output() closed: EventEmitter<void> = new EventEmitter<void>();
}
